<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    {{$t('news.template.minister.new.p1')}}
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.minister.new.p2')}}
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[2]}}"
      class="member-name"
    >{{news.textParams[3]}}</router-link>
    {{$t('news.template.minister.new.p3')}}
    {{news.textParams[4]}}
    {{$t('news.template.minister.new.p4')}}
    {{news.textParams[5]}}.
  </div>
</template>
